import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '../../../Global/Modals/DialogForm';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Formik, FastField } from 'formik';
import ProgressButton from '../../../Global/Buttons/Progress';
import classnames from 'classnames';
import ButtonStyles from '../../../../styles/button';
import TextFieldInput from '../../../../components/Global/Inputs/TextField';
import SpacingStyles from '../../../../styles/helpers/spacing';
import combineStyles from '../../../../utils/combineStyles';
import validationSchema from './ExceptionModal.schema';

export class ExceptionModal extends PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };
  state = { isSubmitting: false };
  _handleCancel = resetForm => {
    const { onClose } = this.props;
    resetForm();
    onClose();
  };
  render() {
    const { open, onClose, t, classes, onSave } = this.props;
    const { isSubmitting } = this.state;
    return (
      <Formik
        handleSubmit={this._handleOnSave}
        enableReinitialize={true}
        validationSchema={validationSchema({ t })}
        initialValues={{
          shipmentExceptionReasonNotes: ''
        }}
        onSubmit={async (values, actions) => {
          this.setState({ isSubmitting: true });
          const savedSuccessfully = await onSave(values);
          if (savedSuccessfully) {
            actions.resetForm();
            this.setState({ isSubmitting: false });
            onClose();
          }
        }}
        render={({ values, handleChange, handleSubmit, handleReset }) => (
          <DialogForm
            open={open}
            title={t('What is the reason for the Exception?')}
            onClose={onClose}
            footer={
              <Fragment>
                <div className={classes.spacer} />
                <Button
                  className={classes.button}
                  onClick={() => {
                    this._handleCancel(handleReset);
                  }}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('Cancel')}
                </Button>
                <ProgressButton
                  color="primary"
                  className={classnames(classes.button)}
                  classes={{
                    label: classnames(classes.buttonLabel)
                  }}
                  onClick={handleSubmit}
                  isSubmitting={isSubmitting}
                >
                  {t('Submit')}
                </ProgressButton>
              </Fragment>
            }
          >
            <Grid container spacing={16}>
              <Grid item lg={12} classes={{ item: classes.verticalGridItem }}>
                <FastField
                  value={values.shipmentExceptionReasonNotes}
                  name={'shipmentExceptionReasonNotes'}
                  label={t('Exception Reason')}
                  onChange={handleChange}
                  component={TextFieldInput}
                />
              </Grid>
            </Grid>
          </DialogForm>
        )}
      />
    );
  }
}
const translatedExceptionModal = withNamespaces()(ExceptionModal);
export default withStyles(combineStyles(SpacingStyles, ButtonStyles))(
  translatedExceptionModal
);
